import Link from 'next/link';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { removeDefaultParams } from '../../../Utils/helper';
import { getRouterLocale } from '../../../Utils/i18Utils/constant';

import {
  Content,
  SimilarVideosCard,
  SimilarVideoSection,
  SimilarVideoThumbnail,
  SimilarVideoThumbnailImg,
  SimilarVideoTitle,
  VideoDescriptionContainer,
  VideoTitle,
  Views,
} from '../../Parenting/ArticlesAndVideos/styled';
import { getSearchParams } from '../../Parenting/common';
import { ArticleSection } from '../OvulationCalculatorBox/styled';
import { ovulationArticles } from '../staticData';
import { fireServedSectionEvent } from '../../../Utils/useFirebase';

export default function OvulationArticles(props) {
  let { heading } = props;
  const router = useRouter();
  const [cardEffect, setCardEffect] = useState({ class: '', index: null });

  useEffect(() => {
    fireServedSectionEvent(heading, '', 'Articles');
  }, []);

  return (
    <ArticleSection>
      <SimilarVideoTitle>Read more on Mylo</SimilarVideoTitle>
      <SimilarVideoSection>
        {ovulationArticles?.map((data, index) => {
          return (
            <Link
              href={{
                pathname: data?.web_url,
                query: removeDefaultParams(router.query),
              }}
              passHref
              key={index}
              locale={false}
              legacyBehavior
            >
              <SimilarVideosCard
                as="a"
                className={index === cardEffect.index && cardEffect.class}
                onClick={(e) => {
                  e.preventDefault();
                  setCardEffect({
                    class: 'lowOpacity',
                    index: index,
                  });
                  setTimeout(() => {
                    router.push(data?.web_url + getSearchParams(), '', {
                      locale: getRouterLocale(router),
                    });
                  }, [200]);
                }}
              >
                <SimilarVideoThumbnail>
                  <SimilarVideoThumbnailImg
                    src={data?.webImg}
                    srcSet={
                      data?.webImg
                        ? `${data?.webImg}?tr=w-140,q-90 140w, ${data?.webImg}?tr=w-400,q-90 400w`
                        : null
                    }
                    sizes={
                      data?.webImg ? '(max-width: 720px) 140px, 400px' : null
                    }
                    alt=""
                    width="100%"
                    loading="lazy"
                  />
                </SimilarVideoThumbnail>
                <VideoDescriptionContainer>
                  <VideoTitle>{data?.title}</VideoTitle>
                  <Content>{data?.desc}</Content>

                  <Views>{data?.views}</Views>
                </VideoDescriptionContainer>
              </SimilarVideosCard>
            </Link>
          );
        })}
      </SimilarVideoSection>
    </ArticleSection>
  );
}
